import { FC, useCallback } from 'react';
import { Divider, HStack, Link, VStack } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Modal from 'components/_core/Modal';
import Text from 'components/_core/Text';
import dashboardLocales from 'features/Dashboard/common/locales';

import Callout from '../../../../../components/_core/Callout';
import { BetaTag } from '../BetaTag';
import BentoChart from './assets/bento-chart.png';
import BentoMain from './assets/bento-main.png';
import InfoBlock from './components/InfoBlock';
import useNeedsAccountingDashboardOnboardingModal from './hooks/useNeedsAccountingDashboardOnboardingModal';
import locales from './locales';

const DashboardOnboardingModal: FC = () => {
  const [needsModal, setNeedsModal] =
    useNeedsAccountingDashboardOnboardingModal();

  const onClose = useCallback(() => {
    setNeedsModal(false);
  }, [setNeedsModal]);

  if (!needsModal) {
    return null;
  }

  return (
    <Modal isOpen onClose={onClose}>
      <Modal.Header />

      <Modal.Body>
        <HStack spacing="space-16">
          <Modal.Image
            borderRadius="radius-12"
            height="180px"
            src={BentoChart}
            width="180px"
          />

          <Modal.Image
            borderRadius="radius-12"
            height="180px"
            src={BentoMain}
            width="340px"
          />
        </HStack>

        <VStack align="flex-start" spacing="space-12">
          <HStack spacing="space-8">
            <Modal.Title>{locales.welcomeToDashboard}</Modal.Title>
            <BetaTag />
          </HStack>

          <Text fontSize="font-15">{locales.subtitle}</Text>
        </VStack>

        <VStack marginTop="space-32" spacing="space-24">
          <InfoBlock
            description={locales.infoBlocks.analyzeVariations.subtitle}
            iconName="clock"
            title={locales.infoBlocks.analyzeVariations.title}
          />

          <Divider />

          <InfoBlock
            description={locales.infoBlocks.financeDetail.subtitle}
            iconName="bulk-transfer"
            title={locales.infoBlocks.financeDetail.title}
          />

          <Divider />

          <InfoBlock
            description={
              <>
                {locales.infoBlocks.feedback.subtitle}{' '}
                <Link
                  fontSize="font-13"
                  href={dashboardLocales.feedback.feedbackLink}
                  target="_blank"
                  variant="inline"
                >
                  {locales.infoBlocks.feedback.subtitleNext}
                </Link>
              </>
            }
            iconName="chat"
            title={locales.infoBlocks.feedback.title}
          />

          <Callout hideIcon variant="info">
            <Callout.Content fontWeight="weight-500">
              {locales.callouts.dataInfo.title}
            </Callout.Content>
          </Callout>
        </VStack>
      </Modal.Body>

      <Modal.Footer justifyContent="flex-end">
        <Button icon="arrow-right" onClick={onClose} variant="primary">
          {locales.mainCTA}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DashboardOnboardingModal;
